import { render, staticRenderFns } from "./createEstGutter.vue?vue&type=template&id=4bafb2bf&scoped=true"
import script from "./createEstGutter.vue?vue&type=script&lang=js"
export * from "./createEstGutter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafb2bf",
  null
  
)

export default component.exports